<template>
  <!-- 推广活动登记列表（统一组件） -->
  <div class="page-container">
    <!-- 标签导航 -->
    <promotion-Top ref="promotionTop" />
    <!-- 数据卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="6">
            <span style="padding-right: 20px"> 登记公司（共{{ aSum }}人）</span>
          </el-col>
          <el-col :span="6">
            <el-input v-model="input">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="serach"
              ></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 表格内容 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80px"></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="linkman" label="联系人" width="100px"></el-table-column>
          <el-table-column prop="position" label="职务" width="100px"> </el-table-column>
          <el-table-column prop="phone_number" label="电话" width="120px"> </el-table-column>
          <el-table-column v-if="config.showInterested" prop="interested" label="推广服务"> </el-table-column>
          <el-table-column v-if="config.showNumber" prop="number" label="参加人数" width="120px"> </el-table-column>
          <el-table-column prop="content" label="留言"></el-table-column>
          <el-table-column v-if="config.showAssociation" prop="type" label="协会邀请" width="100px">
            <template slot-scope="{row}">
              <el-tag v-if="row.type == 4" type="success">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="填写时间"
            width="160"
            sortable
          ></el-table-column>

          <el-table-column prop="is_sms" label="短信通知" width="100px">
            <template slot-scope="{ row }">
              <el-tag v-if="row.is_sms" type="success">已发送</el-tag>

              <el-tooltip v-if="row.is_sms == false"
                class="item"
                effect="dark"
                :content="row.sms_err"
                placement="left"
              >
                <el-tag type="danger">发送失败</el-tag>
              </el-tooltip>

              <el-tag v-if="row.is_sms == null" type="info">无记录</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleClick(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";
import promotion_Top from "../links/promotion_Top";

/** 类型配置映射：1中文网 2英文网 3培训 4培训(协会) 5苏州展出海论坛(东南亚) 6新媒体推广 7轴承网 8facebook */
const typeConfig = {
  1: { apiParam: "type=1",       showInterested: true,  showNumber: false, showAssociation: false },
  2: { apiParam: "type=2",       showInterested: true,  showNumber: false, showAssociation: false },
  3: { apiParam: "type__in=3,4", showInterested: true,  showNumber: false, showAssociation: false },
  5: { apiParam: "type=5",       showInterested: false, showNumber: true,  showAssociation: true  },
  6: { apiParam: "type=6",       showInterested: true,  showNumber: false, showAssociation: false },
  7: { apiParam: "type=7",       showInterested: true,  showNumber: false, showAssociation: false },
  8: { apiParam: "type=8",       showInterested: true,  showNumber: false, showAssociation: false },
};

export default {
  name: "promotionList",
  components: { promotion_Top },
  data() {
    return {
      tableData: [],
      pageCount: 1,
      pagesize: 10,
      currentPage: 1,
      aSum: 0,
      input: "",
      type: "1",
      config: typeConfig[1],
    };
  },
  mounted() {
    this.type = this.$route.query.type || "1";
    this.config = typeConfig[this.type] || typeConfig[1];
    this.getData();
  },
  beforeRouteUpdate(to, from, next) {
    this.type = to.query.type || "1";
    this.config = typeConfig[this.type] || typeConfig[1];
    this.getData();
    next();
  },
  methods: {
    /** 获取推广登记列表数据 */
    getData() {
      let url = this.baseUrl + "/admin/activity_forms/?" + this.config.apiParam;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },
    /** 搜索推广登记记录 */
    serach() {
      let url = this.baseUrl + "/admin/activity_forms/?" + this.config.apiParam + "&search=" + this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },
    /** 分页切换 */
    handleCurrentChange(val) {
      let url = this.baseUrl + "/admin/activity_forms/?" + this.config.apiParam + "&page=" + val + "&search=" + this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },
    /** 删除推广登记记录 */
    handleClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let a_id = row.id;
        let url = this.baseUrl + "/admin/activity_forms/" + a_id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getData();
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .vue-html5-editor > .content {
  max-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/promotion.vue